/* eslint-disable react-hooks/exhaustive-deps */
import _ from 'lodash'
import {
  useSystemSettings,
} from '../../vendor/react-omnitech-api'
import env from '../../config/env'

export default function usePriceTemplate(props = {}) {
  // TODO: get from config
  const availablePriceTemplates = [
    {
      code: 'fnb_mobile_v3',
      type: 'skuQuota',
      version: 3,
    },
    {
      // CP-20210128: v3 price template is used for both membership and fnb cart so
      // instead of modifying the usage in many places we're adding a v3 here for membership type.
      code: 'fnb_mobile_v3',
      type: 'membership',
      version: 3,
    },
    {
      code: 'membership_upgrade_v1',
      type: 'membership',
      version: 1,
    },
    {
      code: 'fnb_mobile_v3',
      type: 'fnb',
      version: 3,
    },
    {
      code: 'fnb_mobile_v1',
      type: 'fnb',
      version: 1,
    },
    {
      code: 'fnb_mobile_v2',
      type: 'fnb',
      version: 2,
    },
    {
      code: 'ecom_v3',
      type: 'ecom',
      version: 3,
    },
    {
      code: 'ecom_v2',
      type: 'ecom',
      version: 2,
    },
  ]
  const { getSystemSetting } = useSystemSettings()
  const fnbEnabled = getSystemSetting('features.fnb.enable')
  const defaultType = fnbEnabled ? 'fnb' : 'ecom'
  const defaultPriceTemplateMatches = { type: defaultType }
  const envPriceTemplateMatches = _.omitBy({
    type: _.get(env, 'config.api.priceTemplateType'),
    version: _.get(env, 'config.api.priceTemplateVersion'),
    code: _.get(env, 'config.api.priceTemplateCode'),
  }, _.isUndefined)
  // gets first match
  const getPriceTemplate = (options = props) => {
    let matches = options
    // if props not contain `type` then fallback to use default type
    if (_.isString(options)) {
      matches = { type: options }
    } else if (
      !_.isPlainObject(options)
      || _.isEmpty(_.pick(options, ['type', 'version', 'code']))
    ) {
      matches = defaultPriceTemplateMatches
      if (!_.isEmpty(envPriceTemplateMatches)) {
        matches = envPriceTemplateMatches
      }
    }
    matches = _.pick(matches, ['type', 'version', 'code'])
    return _.find(availablePriceTemplates, matches)
  }
  // const priceTmpl = _.find(availablePriceTemplates, matches)

  return {
    getPriceTemplate,
    ...getPriceTemplate(),
  }
}
